import { render, staticRenderFns } from "./CampusIndex.vue?vue&type=template&id=2f382c82&"
import script from "./CampusIndex.vue?vue&type=script&lang=js&"
export * from "./CampusIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports